// ventesMobileShared.js — helpers d'affichage de l'écran Ventes mobile.

export const PERM = {
  view: "Gestion Commerciale.Ventes.Ventes.view",
  create: "Gestion Commerciale.Ventes.Ventes.create",
  edit: "Gestion Commerciale.Ventes.Ventes.edit",
  delete: "Gestion Commerciale.Ventes.Ventes.delete",
  viewPayments: "Gestion Commerciale.Ventes.Ventes.view_payments",
  createPayment: "Gestion Commerciale.Ventes.PaiementsEntrants.create",
  pos: "Gestion Commerciale.POS.use",
};

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

/** Statut de paiement → ton de `Pill` du kit .epm (GestionVente.tsx:3338-3341). */
export const paymentPill = (status) => {
  const s = String(status || "Non payé");
  if (s === "Payé") return { tone: "ok", label: "Payé" };
  if (s === "Partiel" || s === "Partiellement payé") return { tone: "warn", label: "Partiel" };
  return { tone: "danger", label: "Non payé" };
};

/** Statut de commande → ton de `Pill` (GestionVente.tsx:3321-3325). */
export const orderPill = (order) => {
  if (order.__offline) return { tone: "draft", label: "En attente sync" };
  const s = String(order.order_status || "En attente");
  if (s === "Annulé") return { tone: "danger", label: s };
  if (s === "En attente") return { tone: "draft", label: s };
  return { tone: "ok", label: s };
};

export const clientNameOf = (order) =>
  order.entity_name || order.user_name || order.client_name || "Client de passage";

export const salesChannelPill = (channel) => {
  if (channel === "ecommerce") {
    return { tone: "info", label: "Boutique en ligne" };
  }
  if (channel === "pos") {
    return { tone: "draft", label: "Point de vente" };
  }
  return { tone: "off", label: "Vente manuelle" };
};

/**
 * Reproduit exactement la logique du desktop (GestionVente.tsx:3420-3439, 3483-3579) :
 * les trois actions sont mutuellement exclusives et dépendent de l'état de la vente.
 * Renvoie "restore" | "cancel" | "delete" | null.
 */
export const destructiveActionFor = (order, canDelete) => {
  if (
    !canDelete ||
    order.__offline ||
    order.record_source === "ecommerce" ||
    order.sales_channel === "ecommerce"
  ) {
    return null;
  }

  const isDelivered = order.delivery_status === "delivered";
  if (isDelivered) return null;

  if (order.is_deleted === 1) return "restore";
  if (num(order.paid_amount) > 0) return "cancel";
  if (order.is_deletable === 0) return null;
  return "delete";
};

/** L'édition reste sur desktop, mais on affiche la même règle d'inhibition. */
export const isEditBlocked = (order) =>
  Boolean(order.__offline) ||
  order.record_source === "ecommerce" ||
  order.sales_channel === "ecommerce" ||
  order.is_deleted === 1 ||
  num(order.paid_amount) > 0 ||
  order.delivery_status === "delivered";
